module.exports = __webpack_public_path__ + "img/initialll.5d8ef1a4.png";